export default "__VITE_ASSET__CzUHSHVh__"